import { Rules } from "./types";

export const RULES_TRANSLATE: Record<Rules, string> = {
  [Rules.Atm]: 'card.cardRules.atm',
  [Rules.ContactlessPayments]: 'card.cardRules.contactless',
  [Rules.Ecommerce]: 'card.cardRules.online',
};